import { render, staticRenderFns } from "./AppSimpleTableWithApi2.vue?vue&type=template&id=42280232&scoped=true&"
import script from "./AppSimpleTableWithApi2.vue?vue&type=script&lang=js&"
export * from "./AppSimpleTableWithApi2.vue?vue&type=script&lang=js&"
import style0 from "./AppSimpleTableWithApi2.vue?vue&type=style&index=0&id=42280232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42280232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressLinear,VSimpleTable,VTooltip})
